import axios from 'axios';

const api = (url, method, reqData, reqHeaders) => {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: method,
      data: reqData,
      headers: reqHeaders
    })
    .then(response => resolve(response.data))
    .catch(error => reject(error));
  });
};

export default api;